export const customColor = {
    primary: "#18A0FB",
    borderColor: "#EDEFF2",
    text: "#092C4C",
    light_text: "#092C4C4D",
    mid_text: "#506981",
    gray: "#F7F8FB",
    purple: "#444EED",
    success: "#27AE60",
    error: "#FF1B1B",
  };
  
  export const theme_primary_colors = {
    tokyo: "#132F60",
    atlantic: "#444EED",
    default: "#18A0FB",
  };
  